/**
 * Validate a Typeform form / template URL.
 *
 * Accepts:
 *   - Direct form links: https://<subdomain>.typeform.com/to/<uid>
 *     Query strings, fragments, and trailing slashes are fine — real-world
 *     links carry tracking params (?source=...&typeform-source=...) and the
 *     uid extractors downstream ignore everything after the uid.
 *   - Template pages: https://www.typeform.com/templates/...
 *
 * TODO: Support vanity slug URLs like https://growens.typeform.com/rge-survey-2026
 * (no /to/ segment). The converter's uid extractor only understands /to/<uid>,
 * so accepting them here would just fail later.
 */
export const isValidTypeformUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url.trim());

    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
      return false;
    }

    // Direct form URL on any typeform subdomain.
    const isTypeformSubdomain = /^[a-zA-Z0-9-]+\.typeform\.com$/.test(parsed.hostname);
    if (isTypeformSubdomain && /^\/to\/[a-zA-Z0-9]+\/?$/.test(parsed.pathname)) {
      return true;
    }

    // Template page.
    if (parsed.hostname === 'www.typeform.com' && parsed.pathname.startsWith('/templates/')) {
      return true;
    }

    return false;
  } catch {
    return false;
  }
};
